module.exports = __webpack_public_path__ + "img/no-trans.7b9afa13.svg";